// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
	<path d="M15.1,2.8c-1-0.5-2-0.8-3.1-0.8C8.4,2,5.5,4.9,5.5,8.5c0,1.1,0.3,2.2,0.8,3.1L12,22l5.7-10.4C19.4,8.4,18.2,4.5,15.1,2.8z
		 M16.8,11.1L16.8,11.1L12,19.9l-4.8-8.8c-1.5-2.7-0.5-6,2.1-7.5c2.7-1.5,6-0.5,7.5,2.1c0.5,0.8,0.7,1.7,0.7,2.7
		S17.3,10.3,16.8,11.1z" />
	<polygon points="12.5,8 15.5,8 15.5,9 12.5,9 12.5,12 11.5,12 11.5,9 8.5,9 8.5,8 11.5,8 11.5,5 12.5,5" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-map-marker-plus-DsPwjQir.js.map
